export const StripeKey =
  'pk_live_51C9vK5IZeT2h6GqBnrcTgg8zghjjk6sT7KJYUubySzaRhN0ywRUznpSl2V0VCvSfATXUqFNTU10Nbz7Yk20c0VPH00O6CTUwfA';
